// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

import Post from "./Post";

type $Props = {
  classes: Object,
  posts: Array<Object>,
};

const BlogPosts = ({ classes, posts }: $Props) => {
  if (posts && posts.length) {
    return (
      <div className={classes.root}>
        <Typography type="heading3">Latest Blog Posts</Typography>
        {posts.map((post) => <Post key={post.id} post={post} />)}
      </div>
    );
  } else {
    return null;
  }
};

const styles = (theme) => ({
  root: {
    flex: "0 1 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "0 16px",
    [theme.breakpoints(768)]: {
      flex: "0 1 41.666%",
    },
  },
  headline: {
    marginBottom: theme.spacing.unit * 1.5,
  },
});

export default withGlobalContext(withStyles(styles)(BlogPosts));
